import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  projectId: "snappily-photo-storage", // create environment variables
  storageBucket: "snappily-photo-storage.firebasestorage.app", // create environment variables
  messagingSenderId: "440188267512", // create environment variables
  appId: "1:440188267512:web:1a0845dbdd750e2ddc040d", // create environment variables
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
